<!--
 * @Author: tjessie
 * @Date: 2025-05-13 16:19:29
 * @LastEditors: tjessie
 * @LastEditTime: 2025-06-10 13:37:44
 * @Description: file content
 * @FilePath: \juqu-pandakt\src\components\mobile\bj.vue
-->
<template>
  <div class="bjBox">
    <img class="bj" :src="bjData.imgUrl" alt="" />
    <div class="titleBox">
      <div>{{ bjData.title }}</div>
      <div>{{ bjData.minTitle }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bjData: Object,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.bjBox {
  position: relative;
}
.bj {
  width: 100%;
  display: block;
}
.titleBox {
  color: #fff;
  position: absolute;
  top: 50%;
  right: 0;
  left: 0;
  bottom: 0;
  margin: auto;
  transform: translateY(-25%);
  text-align: center;

  div:nth-child(1) {
    font-size: 36px;
    font-weight: bold;
    letter-spacing: 10px;
  }
  div:nth-child(2) {
    padding-top: 8px;
    font-weight: lighter;
    font-size: 15px;
  }
}
</style>
